<template>
  <component :is="decoratorComponentName"
             v-if="decoratorComponentName">
    <div class="signAuth">
      <span>{{ $t('oauth2_implements.AboradSignin.quickLogin') }}</span>
      <div class="icon-container">
        <img src="./assets/imgs/Twitter.png"
             alt="Twitter"
             class="login-icon"
             @click="handleLogin('Twitter')" />
        <img src="./assets/imgs/Google.png"
             alt="Google"
             class="login-icon"
             @click="handleLogin('Google')" />
        <img src="./assets/imgs/Facebook.png"
             alt="Facebook"
             class="login-icon"
             @click="handleLogin('Facebook')" />

      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { CORE_AXIOS, Http } from '@/core'
import { container } from 'tsyringe'
import { useOauth2 } from '../Oauth2Plugin'


const axios = container.resolve<Http>(CORE_AXIOS)
const oauth2State = useOauth2()
const { decoratorComponentName } = oauth2State.$state

const handleLogin = async (provider: string) => {
  switch (provider) {
    case 'Twitter':
      try {
        const resultCallBackUrl: string = await axios.get('/v1/api/oauth2/third_parties/twitter/signin')
        console.log(resultCallBackUrl)
        window.location.href = resultCallBackUrl
      } catch (error) {
        console.error('Error:', error)
      }
      break

    case 'Google':
      try {
        const resultGoogleCallBakcUrl: string = await axios.get('/v1/api/oauth2/third_parties/google/signin')
        console.log(resultGoogleCallBakcUrl)
        window.location.href = resultGoogleCallBakcUrl
      } catch (error) {
        console.error('Error:', error)
      }
      break
    case 'Facebook':
      console.log('Logging in with Facebook')
      break
    default:
      console.error('Unknown provider: ' + provider)
  }
}

</script>

<style scoped lang="less">
.signAuth {
  text-align: center;
  margin-top: 20px;

  span {
    font-size: 24px;
    color: rgb(74, 72, 72);
    font-weight: bold;
  }

  .icon-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    .login-icon {
      width: 40px;
      height: 40px;
      margin: 0 15px;
      cursor: pointer;
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.5);
      }
    }
  }
}
</style>
